"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckIsOpenAcct = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var CheckIsOpenAcct = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CheckIsOpenAcct, _super);
    function CheckIsOpenAcct() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '校验是否已做众禄开户';
        _this.code = '106016';
        _this.desc = '校验是否已做众禄开户';
        _this.requestParams = new zl_1.CheckIsOpenAcctRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CheckIsOpenAcct;
}(service_1.BaseService));
exports.CheckIsOpenAcct = CheckIsOpenAcct;
//# sourceMappingURL=checkIsOpenAcct.js.map